export default "__VITE_ASSET__DHarrFF8__"